module.exports = __webpack_public_path__ + "img/stock5.c46f4f11.png";